export const VVDN_BRAND = {
  companyName: 'VVDN Technologies Pvt Ltd',
  productName: 'RF Floor Plan Editor',
  productShortName: 'Floor Plan',
  tagline: 'Proprietary RF simulation · walls · obstacles · optimization',
  copyright: `© ${new Date().getFullYear()} VVDN Technologies Pvt Ltd. All rights reserved.`,
  proprietaryNotice:
    'Proprietary and confidential. RF planning algorithms, heatmap engine, and optimization logic are the exclusive property of VVDN Technologies Pvt Ltd.',
  logos: {
    /** Official SVG from vvdntech.com — transparent, for white header */
    official: '/brands/vvdn/vvdn-logo.svg',
    /** PNG with dark plate — footer / legacy only */
    png: '/brands/vvdn/vvdn-logo.png',
  },
  orgId: '00000000-0000-0000-0000-000000000001',
  siteId: '00000000-0000-0000-0000-000000000002',
  siteName: 'Demo Site',
} as const
